import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Rocket } from 'lucide-react';
import api from '@/lib/api';

export default function Investors() {
  const [items, setItems] = useState([]);
  useEffect(() => {
    api.get('/startups/').then(r => setItems(r.data.filter(s => s.vetting_status === 'approved')));
  }, []);

  return (
    <div>
      <div className="ve-eyebrow">Investor Portal</div>
      <h1 className="display text-3xl md:text-4xl mt-2">Browse vetted ventures.</h1>
      <p className="text-sm text-slate-600 mt-2 max-w-2xl">Only startups that have passed AI Q&A and psychometric vetting are shown here. Initiate an NDA/MOU or a compliance chat directly from a profile.</p>

      <div className="mt-8 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
        {items.length === 0 && (
          <div className="ve-card p-10 text-center md:col-span-3">
            <Rocket size={28} className="mx-auto text-slate-300 mb-3"/>
            <h3 className="display text-xl">No vetted startups yet</h3>
            <p className="text-sm text-slate-600 mt-2">Once founders complete the AI Q&A and psychometric, their startups will appear here.</p>
          </div>
        )}
        {items.map(s => (
          <Link key={s.startup_id} to={`/dashboard/startups/${s.startup_id}`} className="ve-card p-6 group transition-all hover:-translate-y-1 hover:shadow-lg hover:border-[#8B3FC5]/30">
            <div className="flex items-center justify-between">
              <span className="text-xs uppercase tracking-[0.18em] text-slate-500">{s.industry} · {s.stage.replace('_',' ')}</span>
              <span className="text-[10px] px-2 py-0.5 rounded uppercase tracking-[0.15em] bg-emerald-50 text-emerald-700">vetted</span>
            </div>
            <h3 className="display text-xl mt-3 group-hover:text-[#8B3FC5]">{s.name}</h3>
            <p className="text-sm text-slate-600 mt-2 line-clamp-2">{s.tagline}</p>
            <div className="mt-4 grid grid-cols-2 gap-3 text-xs">
              <div>
                <div className="text-slate-500 uppercase tracking-[0.15em]">AI</div>
                <div className="display text-lg text-[#8B3FC5]">{s.ai_score ? Math.round(s.ai_score) : '—'}</div>
              </div>
              <div>
                <div className="text-slate-500 uppercase tracking-[0.15em]">Psycho</div>
                <div className="display text-lg text-[#8B3FC5]">{s.psychometric_score ? Math.round(s.psychometric_score) : '—'}</div>
              </div>
            </div>
            <div className="mt-4 ve-btn-ghost text-xs">View profile <ArrowRight size={12}/></div>
          </Link>
        ))}
      </div>
    </div>
  );
}
